export const TEST_ID = 'authenticationProvider';
